/** Maps to `.ds-status-*` in index.css (uses `--ds-*` tokens) */
const DOMAIN_STATUS_STYLES: Record<string, string> = {
  new: "ds-status-new",
  bought: "ds-status-bought",
  inactive: "ds-status-inactive",
  active: "ds-status-active",
  "active but closed": "ds-status-active-closed",
  redirected: "ds-status-redirected",
  expired: "ds-status-expired",
  "blocked (abuse)": "ds-status-blocked-abuse",
  "blocked (other issue)": "ds-status-blocked-other",
  check: "ds-status-check",
  parked: "ds-status-parked",
  "not available": "ds-status-not-available",
  "not verified": "ds-status-not-verified",
  "in registration process": "ds-status-in-registration",
  "registration failed": "ds-status-registration-failed",
  "verification issues": "ds-status-verification-issues",
  "verification in process": "ds-status-verification-process",
  "re-reg": "ds-status-rereg",
  "re-reg - in registration process": "ds-status-rereg-in-registration",
  "expired - not renewed": "ds-status-expired-not-renewed",
};

const STATUS_UNKNOWN = "ds-status-unknown";

export function getStatusStyles(status: string) {
  const key = status.toLowerCase().trim();
  return DOMAIN_STATUS_STYLES[key] ?? STATUS_UNKNOWN;
}

export function getSiteTypeStyles(type: string) {
  const normalizedType = type.toLowerCase().trim();

  switch (normalizedType) {
    case "brand":
      return "badge-chart-3";
    case "slot":
      return "badge-chart-1";
    case "payment":
      return "badge-chart-2";
    case "review":
      return "badge-chart-5";
    case "info":
      return "badge-chart-4";
    case "301 redirect":
      return "badge-signal-negative";
    case "apps":
      return "badge-chart-4";
    case "mirror links":
      return "badge-chart-5";
    case "review slots":
      return "badge-chart-3";
    case "pbn":
      return "badge-chart-1";
    default:
      return "badge-muted";
  }
}

export function getDomainTypeStyles(type: string) {
  const normalizedType = type.toLowerCase().trim();

  switch (normalizedType) {
    case "new":
      return "badge-muted";
    case "drop":
      return "badge-chart-2";
    default:
      return "badge-muted";
  }
}

export function getCmsStyles(cms: string) {
  const normalizedCms = cms.toLowerCase().trim();

  switch (normalizedCms) {
    case "jetsik":
      return "badge-chart-4";
    case "wp":
    case "wordpress":
      return "badge-chart-2";
    case "html":
      return "badge-signal-negative";
    case "publii":
      return "badge-chart-1";
    case "jetsik/html":
      return "badge-chart-3";
    default:
      return "badge-muted";
  }
}

export function getBrandTypeStyles(type: string) {
  const normalizedType = type.toLowerCase().trim();

  switch (normalizedType) {
    case "new":
      return "badge-chart-2";
    case "old":
      return "badge-chart-5";
    default:
      return "badge-muted";
  }
}

export function getOfferStyles(offer: string) {
  const normalizedOffer = offer.toLowerCase().trim();

  switch (normalizedOffer) {
    case "brand":
      return "badge-chart-3";
    case "cross":
      return "badge-chart-5";
    case "all":
      return "badge-chart-1";
    default:
      return "badge-muted";
  }
}
